<template>
  <div>
    <div class="d-flex justify-space-between align-center px-6 py-3">
      <div>
        <span class="font-14 font-weight-medium">
          CONFIGURAÇÃO DO MIX DAS FILIAIS
        </span>

        <v-btn
          class="ml-5 px-6 py-5 bra-8"
          style="text-transform: none; border-color: #ccc"
          color="#013254"
          @click="dialog_filtros_mix = true"
        >
          <span
            v-if="quantidade_filtros_selecionados > 0"
            style="color: #FFFFFF; font-weight: 400;"
          >
            {{ quantidade_filtros_selecionados }} Filtros aplicados
          </span>

          <span v-else style="color: #FFFFFF; font-weight: 400;">Filtros</span>
          <v-icon class="ml-3" color="#FFFFFF">$Funnel</v-icon>
        </v-btn>

        <v-btn
          v-if="quantidade_filtros_selecionados > 0"
          class="ml-2 px-6 py-5 bra-8 border-gray-400"
          style="text-transform: none;"
          color="#013254"
          @click="dialog_filtros_mix = true"
          outlined
        >
          <span style="font-weight: 500;">
            Editar Filtros
          </span>
        </v-btn>

        <span v-else class="font-14 ml-5" style="color: #E02244">
          <v-icon class="mr-1" color="#E02244">$Warning</v-icon>
          Nenhum filtro aplicado
        </span>
      </div>

      <div>
        <v-btn
          v-if="temSelecionados"
          class="mr-4 px-3 py-5 bra-8"
          style="text-transform: none;"
          color="#0C75BE"
          outlined
          @click="dialog_alterar_em_massa = true"
        >
          <v-icon class="mr-1" color="#0C75BE">$PencilSimpleLine</v-icon>
          <span style="font-weight: 500">Alterar em massa</span>
        </v-btn>

        <v-btn
          class="px-6 py-5 bra-8"
          style="text-transform: none;"
          color="#013254"
          :disabled="!temSelecionados"
          @click="confirmarConfiguracaoMix()"
          outlined
        >
          <span style="font-weight: 500;">
            Confirmar Configuração de Mix
          </span>
        </v-btn>

        <v-btn
          class="ml-4 px-8 py-5 bra-8"
          style="text-transform: none;"
          color="#013254"
          @click="dialog_upload_modelo = true"
        >
          <v-icon class="mr-3" color="#FFFFFF">$UploadSimple</v-icon>
          <span style="color: #FFFFFF; font-weight: 500;">
            Upload do Modelo de Mix
          </span>
        </v-btn>
      </div>
    </div>

    <div class="mx-6 my-1">
      <div>
        <p class="d-inline-flex font-14 font-weight-medium align-center" style="color: #013254;">
          Sumarizadores de Itens

          <span class="ml-1">
            <Legenda
              titulo="Sumarizadores de Itens"
              :legenda="CONTEUDOS_IZINHOS['SUMARIZADORES']"
            >
              <v-icon color="#73787F">$Info</v-icon>
            </Legenda>
          </span>
        </p>
      </div>

      <div class="d-flex" style="flex-wrap: wrap">
        <div class="mr-4" v-for="(item, index) in sumarizadores" :key="index">
          <div :key="index" class="mt-1 w-270 bra-10 border-gray-500">
            <v-card-title style="font-size: 13px; font-weight: bold; color: #013254">
              {{ item.titulo }}

              <span class="ml-1 d-inline-flex align-center">
                <Legenda
                  :titulo="item.titulo"
                  :legenda="CONTEUDOS_IZINHOS[item.chave]"
                >
                  <v-icon color="#73787F">$Info</v-icon>
                </Legenda>
              </span>

              <v-progress-linear
                :value="retornarPorcentagemSumarizadores(item)"
                color="#0060E7"
                height="6"
                class="mt-5 bra-7 mr-10"
              />
            </v-card-title>

            <div class="d-flex position-absolute ml-5 mt-n3 mb-2 font-11">
              <div
                v-if="index === 1 && filtros.filiais.length > 0"
                v-for="(item, idx) in filtros.filiais"
                style="color: #4075FF"
                :key="idx"
              >
                Filial {{ item }}<span
                v-if="filtros.filiais.length > 1 && idx < filtros.filiais.length - 1">,&nbsp;</span>
              </div>
            </div>

            <div class="mt-2">
              <Badge label="TOTAL" :valor="item.total" />
              <Badge label="FILTRADOS" :valor="item.filtrados" :outline="false" />
            </div>
          </div>
        </div>
      </div>

      <div class="mx-2 mt-2">
        <v-text-field
          v-model="search"
          label="Pesquisar"
          clearable
          append-icon="mdi-magnify"
          style="max-width: 400px"
          @input="val => emit('search:change', val)"
          v-lazy-input:debounce="1000"
        />
      </div>

      <v-divider class="mb-n3" />
    </div>

    <FiltrosMixProdutosFilial
      v-model="dialog_filtros_mix"
      @update:filtros="(e) => handleAplicarFiltros(e)"
    />

    <DialogAlterarEmMassa
      v-model="dialog_alterar_em_massa"
      :selecionados="selecionados"
      @upload:concluido="() => uploadConcluido()"
    />

    <DialogUploadModeloMix
      v-model="dialog_upload_modelo"
      @upload:concluido="() => uploadConcluido()"
    />
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";

import FiltrosMixProdutosFilial from "@/components/MixProdutosFilial/componentes/FiltrosMixProdutosFilial/index.vue";
import DialogAlterarEmMassa from "@/components/MixProdutosFilial/componentes/DialogAlterarEmMassa.vue";
import DialogUploadModeloMix from "@/components/MixProdutosFilial/componentes/DialogUploadModeloMix.vue";
import { CONTEUDOS_IZINHOS } from "@/components/MixProdutosFilial/componentes/Dados";
import Badge from "@/components/MixProdutosFilial/componentes/atomos/Badge.vue";
import Legenda from "@/components/produto/detalhes/Legenda.vue";
import api from "@/api/api";

const emit = defineEmits(['update:filtros', 'upload:concluido', 'search:change']);
const filtros = ref({
  filiais: [],
  fornecedores: [],
  segmentos: [],
  secoes: [],
  categorias: [],
  curva_popularidade: [],
  curva_financeira: [],
  possui_venda: [],
  movimentacao: [],
  pertence_ao_mix: [],
  produtos_combinados: false,
  produtos_nao_combinados: true,
  produtos_ativos: true,
  produtos_inativos: false,
  produtos_estoque_zero: false
});

const dialog = ref(false);
const dialog_upload_modelo = ref(false);
const dialog_filtros_mix = ref(false);
const dialog_alterar_em_massa = ref(false);
const search = ref('');

const quantidade_filtros_selecionados = ref(2);
const sumarizadores = ref([]);

onMounted(() => buscarSumarizadores());
const props = defineProps({
  temSelecionados: Boolean,
  selecionados: Array
});

function handleAplicarFiltros(e) {
  let i = 0;

  for (const [key, value] of Object.entries(e)) {
    if (arrayValido(value) || boleanoValido(value) || inteiroValido(value)) i += 1;
  }

  quantidade_filtros_selecionados.value = i;
  emit('update:filtros', { ...e });
  filtros.value = e;

  buscarSumarizadores();
}

function buscarSumarizadores() {
  const body = {
    ...filtros.value
  }

  api.post('mix-produtos-filial/buscar-sumarizadores', body)
  .then(response => sumarizadores.value = response.data.sumarizadores)
  .catch(() => console.error('Não foi possível buscar os sumarizadores.'));
}

function confirmarConfiguracaoMix() {
  const produtos = props.selecionados.map(s => ({
    idfilial: s.filial,
    idproduto: s.idproduto,
    movimentacao: s.movimentacao,
    pertence_ao_mix: s.pertence_ao_mix
  }));

  const body = {
    produtos
  }

  api.post('mix-produtos-filial/confirmar-alteracao-mix', body)
  .then(() => uploadConcluido())
  .catch(() => console.error('Não foi possível salvar as alterações.'));
}

function retornarPorcentagemSumarizadores(item) {
  return item.total > 0 ? (item.filtrados / item.total) * 100 : 0
}

function arrayValido(array) {
  return (Array.isArray(array) && array.length > 0);
}

function boleanoValido(bool) {
  return (typeof bool === "boolean" && bool === true);
}

function inteiroValido(int) {
  return (typeof int === "number" && int >= 0);
}

function uploadConcluido() {
  emit('upload:concluido');
}

</script>

<style scoped>
</style>
